export default __webpack_public_path__ + "static/media/algoColR1.e9d211a6.svg";